import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewAstronMembersForm from "../../../components/apps/astronmembers/NewAstronMembersForm";

export default function NewAstronMembers() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/astronmembers`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Nova Integração AstronMembers"
                description="Criar nova integração AstronMembers"
            />
            <PageBreadcrumb
                pageTitle="Nova Integração AstronMembers"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewAstronMembersForm
                    onSuccess={() => {
                        // Redirecionar para a página de AstronMembers
                        navigate(`/apps/astronmembers`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar integração AstronMembers:", error);
                    }}
                />
            </div>
        </>
    );
}
